import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateEvent } from '@app-models/site';

import { Moment } from 'moment';
import * as moment from 'moment';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { ThaiMomentDateAdapter } from '../../../thai-moment-date-adapter';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { SiteService } from '@app-services/site.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { checkInvalid } from '../../../validation';


@Component({
  selector: 'app-date-dialog',
  templateUrl: './date-dialog.component.html',
  styleUrls: ['./date-dialog.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'th' },
    { provide: DateAdapter, useClass: ThaiMomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class DateDialogComponent implements OnInit {
  @ViewChild('form') formElementRef: ElementRef;
  fg: FormGroup;
  minDate: Date;
  maxDate: Date;
  dates: DateEvent[];
  openOnWeekends: boolean;
  errorMessage: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ss: SiteService,
    private fb: FormBuilder,
    private dap: DateAdapter<Moment>) {
      this.dates = [...data.holidays];
      this.openOnWeekends = data.openOnWeekends;
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      name: [null, Validators.required],
      date: [null, Validators.required]
    });
    const currentYear = new Date().getFullYear();
    this.minDate = new Date();
    this.maxDate = new Date(currentYear + 1, 11, 31);
  }

  addDate(): void {
    if (!checkInvalid([this.fg], this.formElementRef, true)) {

      const newDate: DateEvent = {
        date: this.fg.get('date').value,
        name: this.fg.get('name').value
      };
      const index = this.dates.findIndex(
        (v: DateEvent) => v.date.isSame(newDate.date, 'day'));
      if (index > -1) {
        this.deleteDate(index);
      }
      this.dates.push(newDate);
      this.dates = this.dates.sort((a: DateEvent, b: DateEvent) => {
        if (a.date.isBefore(b.date)) { return -1; }
        if (a.date.isAfter(b.date)) { return 1; }
        return a.name.localeCompare(b.name);
      });
      this.fg.reset();
      Object.keys(this.fg.controls).forEach(key => {
        this.fg.get(key).setErrors(null);
      });
      this.fg.markAsUntouched();
    }
  }

  deleteDate(index: number): void {
    if (index > -1 && index < this.dates.length) {
      this.dates.splice(index, 1);
    }
  }

  addGoogleHolidays() {
    const year = moment().year();
    this.ss.getGoogleHolidays(year, year + 1).then((holidays: DateEvent[]) => {
      console.log(holidays);
    });
  }

  formatDate(date: Moment): string {
    return date.locale('th').format('D MMMM') + ' ' + (date.year() + 543);
  }

  exportDatesToCSV() {
    const sep = '\t';
    const headers = ['date', 'name'];
    const csvContent = headers.join(sep) +
      '\n' +
      this.dates.map((d: DateEvent) => {
        return this.dap.format(d.date, 'DD/MM/YYYY') + '\t' + d.name;
      }).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'holidays.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  importCSV(event: any): void {
    const files = event.target.files;
    if (files.length > 0) {
      const file = files[0];
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (ev: ProgressEvent<FileReader>) => {
        let text = ev.target.result;
        const dates: DateEvent[] = [];
        if (text instanceof ArrayBuffer) {
          const dec = new TextDecoder('utf-8');
          text = dec.decode(text);
        }
        const lines = text.split(/\r\n|\n/);
        lines.splice(0, 1);
        let pastDates = 0;
        let tooFarDates = 0;
        for (const line of lines) {
          if (line.trim().length === 0) {
            continue;
          }
          const parts = line.split('\t');
          const newDate: DateEvent = {
            date: this.dap.parse(parts[0], 'l'),
            name: parts[1]
          };

          const dayDiff = newDate.date.diff(moment(), 'days');
          if (dayDiff < 0) {
            pastDates++;
          }
          if (newDate.date.year() > moment().year() + 1) {
            tooFarDates++;
          }
          const index = dates.findIndex(
            (v: DateEvent) => v.date.isSame(newDate.date, 'day'));
          if (index > -1) {
            dates.splice(index, 1);
          }
          dates.push(newDate);
        }
        if (pastDates > 0 && tooFarDates > 0) {
          this.errorMessage = 'มีวันที่ผ่านไปแล้วและวันที่ล่วงหน้าเกินหนึ่งปีในไฟล์ที่อัพโหลด';
        } else if (pastDates > 0) {
          this.errorMessage = 'มีวันที่ผ่านไปแล้วในไฟล์ที่อัพโหลด';
        } else if (pastDates > 0 && tooFarDates > 0) {
          this.errorMessage = 'มีวันที่ล่วงหน้าเกินหนึ่งปีในไฟล์ที่อัพโหลด';
        } else {
          this.errorMessage = null;
        }
        if (pastDates > 0 || tooFarDates > 0) {
          return;
        }
        this.dates = dates;
        this.dates = this.dates.sort((a: DateEvent, b: DateEvent) => {
          if (a.date.isBefore(b.date)) { return -1; }
          if (a.date.isAfter(b.date)) { return 1; }
          return a.name.localeCompare(b.name);
        });

      };
    }
  }
}
